import {defineComponent} from 'vue';
import gemeentesQuery from '~/graphql/queries/gemeentes/gemeentes.gql';
import userOptionsQuery from '~/graphql/queries/user/options.gql';
import {Gemeente} from '~/graphql/graphql';

export default defineComponent({
  apollo: {
    gemeentes: {
      query: gemeentesQuery,
    },

    userOptions: {
      query: userOptionsQuery,
    },
  },

  data() {
    return {
      gemeentes: [] as Gemeente[],
    };
  },

  computed: {
    gemeenteOptions() {
      return this.gemeentes.map((gemeente: Gemeente) => ({
        label: gemeente.title,
        value: gemeente.id,
      }));
    },
  },
});
